import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export function getMeshRecommendationsApi({ module, instanceId }) {
  const url = endpoints.meshRecommendations;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      module,
      instanceId,
    },
  });
}
